import React, {Component} from 'react';
import FacebookLogin from 'react-facebook-login';
import {inject, observer} from 'mobx-react';
import Utils from './../../utils/Utils';
import Alert from './../Alert';
import Button from 'components/Button';
import { t, isIntlPhone, INTL_PHONE_RE } from 'i18n';

import "./Register.scss";

@inject("AuthStore", "AdventuresStore", "ApplicationStore")
@observer
class Register extends Component {

    static defaultProps = {
        openModal: () => {
        },
        closeModal: () => {
        },
        goToPage: () => {
        }
    };

    constructor(props) {
        super(props);

        this.state = {
            menuOpen: false,
            name: '',
            email: '',
            phone: '',
            password: '',
            alert: false,
            emailRight: false,
            phoneRight: false,
            formError: {
                status: false,
                message: ""
            }
        };

    }


    componentWillReceiveProps(props) {
        this.setState({...props});
    }

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validatePhone(phone) {
        if (isIntlPhone()) {
            return INTL_PHONE_RE.test(String(phone || ''));
        }
        const re = /^\d{10,11}$/;
        return re.test(phone);
    }

    closeModal() {
        this.props.closeModal();
    }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        if (name === "email") {
            if (Utils.validateEmail(value) === false) {
                this.setState({
                    emailRight: false
                });
            } else {
                this.setState({
                    emailRight: true
                });
            }
        }

        if (name === "phone") {
            if (Utils.validatePhone(value) === false) {
                this.setState({
                    phoneRight: false
                });
            } else {
                this.setState({
                    phoneRight: true
                });
            }
        }

        this.setState({
            [name]: value
        });
        this._checkFields(name);

    }

    _checkFields(name) {
        if (this.state[name] === "" || this.state[name] === false || this.state[name] === undefined) {
            this.setState({
                [name + "Error"]: true
            });
        } else {
            this.setState({
                [name + "Error"]: false
            });
        }
    }

    handleInputBlur(e) {
        const name = e.target.name;
        this._checkFields(name);
    }

    handleSubmitForm(e) {
        if (e) {
            e.preventDefault();
        }

        const {AuthStore, goToPage, ApplicationStore} = this.props;

        if (this.state.name !== "" && this.state.email !== "" && this.state.phone !== "" && this.state.phoneRight === true && this.state.senha !== "" && this.state.emailRight === true) {
            const params = {
                "name": this.state.name,
                "email": this.state.email,
                "phone": this.state.phone,
                "password": this.state.password
            };

            AuthStore.register(params).then((response) => {
                if (response.data.success === true) {
                    AuthStore.login(params).then((response) => {
                        if (response.success === true) {
                            if (AuthStore.reloadPageAfterLogin) {
                                window.location.reload();
                            } else if (AuthStore.pageAfterLogin !== "") {
                                goToPage(AuthStore.pageAfterLogin);
                                ApplicationStore.closeModal();
                            }
                        }
                    });
                } else {

                    this.setState({
                        formError: {
                            status: true,
                            message: response.data.data.message
                        }
                    });
                }
            }).catch(err => {
                this.setState({
                    formError: {
                        status: true,
                        message: err.data.message
                    }
                });
            });
        } else {
            this.checkFields("name");
            this.checkFields("email");
            this.checkFields("phone");
            this.checkFields("password");
        }

    }

    responseFacebook(response) {

        const {AuthStore, AdventuresStore, goToPage, ApplicationStore} = this.props;
        const params = {
            name: response.name,
            email: response.email,
            token: response.accessToken,
            photo: response.picture.data.url
        };

        AuthStore.loginSocial(params).then((response) => {

            if (response.success) {
                this.setState({
                    formError: {
                        status: false,
                        message: t('auth.loggedIn')
                    }
                });
                ApplicationStore.closeModal();
                AdventuresStore.page = 1;
                if (AuthStore.reloadPageAfterLogin) {
                    window.location.reload();
                } else if (AuthStore.pageAfterLogin !== "") {
                    goToPage(AuthStore.pageAfterLogin);
                }
            } else {
                this.setState({
                    formError: {
                        status: true,
                        message: t('auth.facebookError')
                    }
                });
            }

        });


    }

    closeAlert() {
        this.setState({
            formError: {}
        });
    }

    handleGoToLogin() {
        const {ApplicationStore} = this.props;
        ApplicationStore.openModalLogin();
    }

    handleForgotPassword() {
        const {ApplicationStore} = this.props;
        ApplicationStore.openModalForgotPassword();
    }

    render() {

        const {AuthStore} = this.props;

        return (
            <div className="Register">
                <div className="modal-content">
                    <div className="facebook-login">
                        <FacebookLogin
                            appId="342755846164051"
                            autoLoad={false}
                            fields="name,email,picture.width(500).height(500)"
                            callback={this.responseFacebook.bind(this)}
                            isMobile={Utils.mobileCheck()}
                            disableMobileRedirect={true}
                            cssClass="btn btn-social btn-facebook btn-inner-card"
                            icon="fa-facebook"
                            textButton={(AuthStore.loading ? <div><i className='fa fa-spinner fa-spin'></i></div> : <div>{t('auth.facebook')}</div>)}
                        />
                    </div>
                    <div className="Grid Grid-cell separator-or">
                        <div className="Grid-cell">
                            <hr />
                        </div>
                        <div className="Grid-cell text-quicksand-muted text-center">
                            {t('auth.or')}
                        </div>
                        <div className="Grid-cell">
                            <hr />
                        </div>
                    </div>
                    <form onSubmit={this.handleSubmitForm.bind(this)}>
                        <div className="  input-cell">
                            <div className="full-width group-input">
                                <input className="full-width"
                                       type="text"
                                       required
                                       value={this.state.name}
                                       onChange={this.handleInputChange.bind(this)}
                                       onBlur={this.handleInputBlur.bind(this)}
                                       name="name"
                                       autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span
                                    className="help-hasError">{(this.state.nameError === true ? ' ' + t('validation.requiredField', { field: t('auth.name') }) : '')}</span>
                                <label>{t('auth.name')}</label>
                            </div>
                        </div>

                        <div className="  input-cell">
                            <div className="full-width group-input">
                                <input className="full-width"
                                       type="text"
                                       required
                                       value={this.state.email}
                                       onChange={this.handleInputChange.bind(this)}
                                       onBlur={this.handleInputBlur.bind(this)}
                                       name="email"
                                       autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span
                                    className="help-hasError">{(this.state.emailRight === false && this.state.emailError === false ? ' ' + t('validation.invalidField', { field: t('auth.email') }) : '')}</span>
                                <span
                                    className="help-hasError">{(this.state.emailError === true ? ' ' + t('validation.requiredField', { field: t('auth.email') }) : '')}</span>
                                <label>{t('auth.email')}</label>
                            </div>
                        </div>

                        <div className="input-cell">
                            <div className="full-width group-input">
                                <input className="full-width"
                                       type="text"
                                       required
                                       value={this.state.phone}
                                       onChange={this.handleInputChange.bind(this)}
                                       onBlur={this.handleInputBlur.bind(this)}
                                       name="phone"
                                       autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span
                                    className="help-hasError">{(this.state.phoneRight === false && this.state.phoneError === false ? ' ' + t('validation.invalidField', { field: t('auth.phone') }) : '')}</span>
                                <span
                                    className="help-hasError">{(this.state.phoneError === true ? ' ' + t('validation.requiredField', { field: t('auth.phone') }) : '')}</span>
                                <label>{t('auth.phone')}</label>
                            </div>
                        </div>

                        <div className="  input-cell">
                            <div className="full-width group-input">
                                <input
                                    className="full-width"
                                    type="password"
                                    required
                                    value={this.state.password}
                                    onChange={this.handleInputChange.bind(this)}
                                    onBlur={this.handleInputBlur.bind(this)}
                                    name="password"
                                    autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span
                                    className="help-hasError">{(this.state.passwordError === true ? ' ' + t('validation.requiredField', { field: t('auth.password') }) : '')}</span>
                                <label>{t('auth.password')}</label>
                            </div>
                        </div>
                        <Alert formError={this.state.formError} closeAlert={this.closeAlert.bind(this)}/>
                        <div className=" ">
                            <Button loading={AuthStore.loading} type="primary" size="full">
                                {(AuthStore.loading ? <div><i className='fa fa-spinner fa-spin'></i></div> :
                                    <div>{t('auth.signupButton')}</div>)}
                            </Button>
                        </div>
                        <div className="other-links">
                            <div className="enter-link" onClick={this.handleGoToLogin.bind(this)}>
                                {t('auth.signin')}
                            </div>
                            <div onClick={this.handleForgotPassword.bind(this)}>
                                {t('auth.forgot')}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


export default Register;